module.exports = {
  "APP_NAME": "Fast",
  "APP_ORIGIN": "mediafire.com",
  "APP_VERSION": "0.1.0",
  "STORE_VERSION": 4
}
